import Vue from "vue";
import Router from "vue-router";
import Landing from "@/views/Landing.vue";
import Index from "@/views/Index.vue";
import PayNotify from "@/views/PayNotify.vue";
import { isWidget } from "@/utils/platform";
Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      // 官网落地页（仅网页端）。桌面壳 / 手机端打开即是计时器，
      // query（如支付回调的 payStatus）原样带去 /app。
      path: "/",
      name: "Landing",
      component: Landing,
      beforeEnter(to, from, next) {
        if (isWidget()) next({ path: "/app", query: to.query, replace: true });
        else next();
      },
    },
    {
      path: "/app",
      name: "Index",
      component: Index,
    },
    {
      path: "/payNotify",
      name: "PayNotify",
      component: PayNotify,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior(to) {
    if (to.hash) return { selector: to.hash, behavior: "smooth" };
    return { x: 0, y: 0 };
  },
});
